import { render, staticRenderFns } from "./DialogTaskAssignment.vue?vue&type=template&id=5a119d62&scoped=true"
import script from "./DialogTaskAssignment.vue?vue&type=script&lang=js"
export * from "./DialogTaskAssignment.vue?vue&type=script&lang=js"
import style0 from "./DialogTaskAssignment.vue?vue&type=style&index=0&id=5a119d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a119d62",
  null
  
)

export default component.exports